'use strict';

/* global $ */
/* global _ */
/* global Backbone */
/* global Marionette */

// import * as InputCheck from '../../utils/input_check';

// import toPrice from '../../utils/price';

import {
    ProductDelete,
    ProductCount,
    ProductSumm } from './core/views';

import toPrice from '../../utils/price';

function Basket(options){
    var opt = _.merge({ }, {
        product: '.js-product-basket',
        product_count: '.js-product-basket-count',
        product_buy: '.js-product-basket-buy',
        product_summ: '.js-product-basket-summ',
        product_delete: '.js-product-basket-delete',
        defaults: {
            count: 0,
            price: 0,
            summ: 0,
            product_id: undefined,
            is_in_basket: true,
            is_progress: false,
            can_add_to_basket: false
        },
        summary: {
            total: '.js-basket-total',
        },
        checkout: {
            wrap: '.js-basket-checkout',
            delivery: {
                wrap: '.js-basket-delivery',
                type: '.js-basket-delivery-type',
                address: '.js-basket-delivery-address'
            },
            info: '.js-basket-info'
        }
    }, options);

    let basketRadio = Backbone.Radio.channel('basket');

    class ProductModel extends Backbone.Model {
        defaults() {
            return opt.defaults;
        }
        initialize() {
            let self = this;

            self.timeout = null;

            self.listenTo(basketRadio, 'changed:in:basket', self.checkProductIsAdded);
            self.listenTo(basketRadio, 'removed:from:basket', self.checkProductIsRemoved);
            self.listenTo(self, 'change:count', self.changeSumm);
            self.listenTo(self, 'change:count', self.changeInBasket);
            // self.listenTo(self, 'change:count', self.checkCanAddToBasket);
            self.listenTo(self, 'is:ready', function(){
                // self.checkCanAddToBasket();
                self.changeSumm();
            });
        }
        changeSumm() {
            let self = this;
            self.set('summ', self.get('price') * self.get('count'));
        }
        checkProductIsRemoved(product){
            let self = this;
            if(self.get('hash') == product.hash){
                self.set({ in_progress: false });
                self.destroy();
            }
        }
        removeFromBasket(){
            let self = this;
            if(window.confirm('Вы уверены, что хотите удалить товар из корзины?')){
                self.set('is_progress', true);
                basketRadio.trigger('remove:from:basket', self);
            }else{
                if(self.get('count') == 0){
                    self.set('count', self.get('step') || 1);
                    self.trigger('on:value:changed', 'count');
                }
            }
        }
        changeInBasket(){
            let self = this;

            if(self.timeout){
                window.clearTimeout(self.timeout);
            }
            if(self.get('count') == 0){
                self.removeFromBasket();
            } else {
                self.timeout = window.setTimeout(function() {
                    self.set('is_progress', true);
                    basketRadio.trigger('add:to:basket', self);
                }, 300);
            }

        }
    }

    class ProductCollection extends Backbone.Collection {
        model() {
            return ProductModel;
        }
        initialize(){
            let self = this;
            self.listenTo(self, 'destroy', self.checkModelsCount);
        }
        checkModelsCount(){
            let self = this;
            if(self.models.length === 0){
                window.location.reload();
            }
        }
    }

    class Product extends Marionette.View {
        template(){ return false; }
        ui() {
            return {
                // 'buy': opt.product_buy,
                'count': opt.product_count,
                'summ': opt.product_summ,
                'delete': opt.product_delete
            };
        }
        regions() {
            return {
                // 'buy': '@ui.buy',
                'count': '@ui.count',
                'summ': '@ui.summ',
                'delete': '@ui.delete'
            };
        }
        childViewEvents() {
            return {
                'addToBasket:view': 'addToBasket',
                'removeFromBasket:view': 'removeFromBasket'
            };
        }
        modelEvents(){
            return {
                'destroy': 'remove'
            };
        }
        initialize() {
            let self = this;

            let hash = self.$el.data('hash');
            let by_weight = self.$el.data('byWeight');
            let price = self.$el.data('price');
            let count = self.$el.data('count');
            let step = self.$el.data('step');
            let is_in_basket = self.$el.data('inBasket');

            self.model.set({
                hash: hash,
                by_weight: by_weight,
                price: price,
                count: count,
                is_in_basket: is_in_basket,
                can_add_to_basket: ((count > 0) ? true : false),
                step: step || 1
            }, { silent: true });

            self.showChildView('count', new ProductCount({ model: self.model }));
            self.showChildView('summ', new ProductSumm({ model: self.model }));
            self.showChildView('delete', new ProductDelete({ model: self.model }));

            self.model.trigger('is:ready');
        }
        removeFromBasket() {
            let self = this;
            self.model.removeFromBasket();
        }
    }

    class Total extends Marionette.View {
        template() {
            return false;
        }
        modelEvents() {
            return {
                'change:total': 'render',
            };
        }
        render() {
            let self = this;
            self.$el.html(toPrice({ price: self.model.get('total'),
                                    kop: true,
                                    sign: 'р' }));
            return self;
        }
    }

    class CheckoutDelivery extends Marionette.View {
        template() {
            return false;
        }
        ui() {
            return {
                'type': '.js-basket-delivery-type',
                'address': '.js-basket-delivery-address',
                'select': '.js-basket-delivery-type__select',
            };
        }
        events(){
            return {
                'change @ui.select': 'onTypeChange'
            };
        }
        initialize() {
            let self = this;

            self.options = [];

            let $type = self.getUI('type');
            if($type.length > 0) {
                let $items = $type.find('.js-basket-delivery-type__item');
                let i = 0;
                while(i < $items.length){
                    self.options.push({
                        id: $items.eq(i).data('id'),
                        name: $items.eq(i).data('name'),
                        comment: $items.eq(i).html(),
                        needAddress: $items.eq(i).data('needAddress')
                    });
                    i++;
                }

                if(self.options.length > 0){
                    let $select = $(document.createElement('select'))
                                            .attr({ name: 'delivery'})
                                            .addClass('js-basket-delivery-type__select');
                    let i = 0;
                    while(i < self.options.length){
                        $(document.createElement('option'))
                                        .attr({ value: self.options[i].id })
                                        .text(self.options[i].name)
                                        .appendTo($select);
                        i++;
                    }

                    $select.appendTo($type)
                           .selectBox({ mobile: true,
                                        menuTransition: 'fade',
                                        menuSpeed: 'fast' });

                    self.$comment = $(document.createElement('div'))
                                            .addClass('form__comment')
                                            .appendTo($type);

                    self.$select = $select;
                    self.$select.trigger('change');
                }
            }
        }
        onTypeChange() {
            let self = this;
            let value = self.$select.selectBox('value');
            let option = _.find(self.options, function(o){
                return o.id == value;
            });
            if(option){
                let $address = self.getUI('address');
                $address.removeClass('m--error');
                if(option.needAddress){
                    $address.show();
                }else{
                    $address.hide();
                }
                self.$comment.html(option.comment);
            }
        }
        getValues(){
            let self = this;

            let answer = {
                fields: [],
                error: false
            };

            let value = self.$select.selectBox('value');
            let option = _.find(self.options, function(o){
                return o.id == value;
            });

            if(option) {
                answer.fields.push({ name: 'delivery',
                                     value: value });
                let $address = self.getUI('address');
                $address.removeClass('m--error');

                if(option.needAddress){
                    let address_value = $address.find('textarea').val();

                    if(address_value == ''){
                        answer.error = true;
                        $address.addClass('m--error');
                    }else{
                        answer.fields.push({ name: 'address',
                                             value: address_value });
                    }
                }
            }else{
                answer.error = true;
            }
            return answer;
        }
    }

    class CheckoutState extends Backbone.Model {
        defaults() {
            return {
                is_loading: false,
                error_text: ''
            };
        }
    }

    class CheckoutError extends Marionette.View {
        getTemplate() {
            return _.template('<div class="error"><%- error_text %></div>');
        }
        modelEvents(){
            return {
                'change:error_text': 'render'
            };
        }
        onRender(){
            let self = this;
            if(self.model.get('error_text')){
                self.$el.show();
            }else{
                self.$el.hide();
            }
        }
    }

    class Checkout extends Marionette.View {
        template() {
            return false;
        }
        ui() {
            return {
                'delivery': '.js-basket-delivery',
                'info': '.js-basket-info',
                'submit': '.js-basket-submit',
                'error': '.js-basket-checkout-error'
            };
        }
        modelEvents() {
            return {
                'change:is_loading': 'changeLoadingState'
            };
        }
        events() {
            return {
                'click @ui.submit': 'orderSubmit'
            };
        }
        initialize() {
            let self = this;

            self.listenTo(basketRadio, 'order:submited', self.checkSubmitStatus);

            self.delivery = undefined;

            let $delivery = self.getUI('delivery');
            if($delivery.length){
                self.delivery = new CheckoutDelivery({  el: $delivery});
            }

            let $error = self.getUI('error');
            if($error.length){
                self.error = new CheckoutError({
                    model: self.model,
                    el: $error
                });
            }
        }
        orderSubmit() {
            let self = this;

            if(!self.model.get('is_loading')){
                let error = false;
                let error_fields = [];
                let data = [];
                if(self.delivery) {
                    let delivery = self.delivery.getValues();

                    if(delivery.error){
                        error = true;
                        error_fields.push('address');
                    }else{
                        _.each(delivery.fields, function(item){
                            data.push(item);
                        });
                    }
                }

                let $fields = self.getUI('info').find('.form__item');
                let i = 0;
                while(i < $fields.length){
                    let $field = $fields.eq(i);
                    let $input = $field.find('input, textarea');
                    if($input.length){
                        let name = $input.attr('name');
                        let value = $.trim($input.val());
                        if($field.hasClass('m--required')){
                            if(value == ''){
                                error_fields.push(name);
                                error = true;
                            }
                        }
                        data.push({ name: name,
                                    value: value });
                    }
                    i++;
                }

                if(error){
                    self._markError(error_fields);
                    self._scrollToStart();
                }else{
                    let send_data = {};

                    _.each(data, function(item){
                        send_data[item.name] = item.value;
                    });

                    self.model.set({
                        'is_loading': true,
                        'error_text': ''
                    });

                    basketRadio.trigger('order:submit', send_data);
                }
            }
        }
        checkSubmitStatus(response){
            let self = this;

            self.model.set('is_loading', false);

            if(response){
                if(response.data.status === 'ok'){
                    basketRadio.trigger('order:is:success', 'ok');
                    if(response.data.order_url){
                        window.location.assign(response.data.order_url);
                    }
                } else {
                    self.model.set('error_text', response.data.error_text);

                    self._scrollToStart();
                    switch(response.data.error_code){
                    case 'FIELDS_ERROR':
                        self._markError(response.data.errors);
                        break;
                    case 'ORDER_NOT_CREATED':
                        self._scrollToStart();
                        break;
                    }
                }
            }
        }
        changeLoadingState(){
            let self = this;
            if(self.model.get('is_loading')){
                self.getUI('submit').addClass('is-sending-order');
            }else{
                self.getUI('submit').removeClass('is-sending-order');
            }
        }
        _markError(fields){
            let self = this;
            let $fields = self.$el.find('.form__item');
            $fields.removeClass('m--error');

            _.each(fields, function(item){
                $fields.filter('.attr-'+item).addClass('m--error');
            });
        }
        _scrollToStart(){
            let self = this;
            let position = self.$el.offset();
            let scrollBody = document.documentElement;
            $(scrollBody).animate({ scrollTop: position.top }, 300, 'swing');
        }
    }


    let $products = $(opt.product);
    if($products.length > 0) {
        let products = new ProductCollection();

        let i = 0;
        while(i < $products.length){
            let product = new ProductModel();

            new Product({
                model: product,
                el: $products.eq(i)
            });

            products.add(product);
            i++;
        }
    }

    let $total = $(opt.summary.total);
    if(($total) && (opt.state)){
        new Total({ el: $total,
                    model: opt.state });
    }

    let $checkout = $(opt.checkout.wrap);
    if($checkout.length){

        new Checkout({
            model: new CheckoutState(),
            el: $checkout
        });
    }
}

export { Basket };
